import { useNavigate } from 'react-router-dom';
import './styles/CTABanner.css';

const CTABanner: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="cta-banner">
      <div className="cta-banner__content">
        <h3 className="cta-banner__title">Ready to create?</h3>
        <p className="cta-banner__sub">Build a game in under 2 minutes</p>
        <button
          className="cta-banner__btn"
          onClick={() => navigate('/dashboard/games')}
        >
          + Create a Game
        </button>
      </div>
      <span className="cta-banner__icon">⚡</span>
    </div>
  );
};

export default CTABanner;
